module.exports = __webpack_public_path__ + "img/keiaien.45056546.jpg";